export default {
    'name': 'caret-slider',
    'width': '81',
    'height': '81',
    'viewBox': '0 0 81 81',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M61.497 53.3119C61.8886 53.7035 62.5236 53.7035 62.9152 53.3119C63.3068 52.9203 63.3068 52.2854 62.9152 51.8937L39.2306 28.2091C39.0425 28.021 38.7874 27.9154 38.5215 27.9154C38.2555 27.9154 38.0005 28.021 37.8124 28.2091L14.1278 51.8937C13.7361 52.2853 13.7361 52.9203 14.1278 53.3119C14.5194 53.7035 15.1543 53.7035 15.5459 53.3119L38.5215 30.3363L61.497 53.3119Z\' fill=\'#006CFD\'/>'
}
